<template>
  <div>
    <h1>司命真君靈籤</h1>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>

    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>順序</th>
        <th>編號</th>
        <th>標題</th>
        <th>內容</th>
        <th>解曰</th>
        <th>詩文解釋</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td class="text-center">
          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="fa fa-trash-alt">  </i></a>
        </td>
        <td width="200px">
          <input type="number" class="form-control"  placeholder="" v-model.number="item.seq">
        </td>
        <td width="200px">
          <input type="text" class="form-control"  placeholder="" v-model="item.no">
        </td>
        <td width="200px">

          <div class="form-inline">
          <input type="text" class="form-control"  placeholder="" v-model="item.title1" style="width: 80px">
          <input type="text" class="form-control"  placeholder="" v-model="item.title2" style="width: 80px">
          </div>
        </td>
        <td >
          <span v-html="item.content"></span>
          <a class="btn btn-primary" href="#" @click="editHtmlContent('content',item,item.content)"><i class="fa fa-pen"></i></a>
        </td>
        <td >
          <span v-html="item.answer"></span>
          <a class="btn btn-primary" href="#" @click="editHtmlContent('answer',item,item.answer)"><i class="fa fa-pen"></i></a>
        </td>
        <td >
          <span v-html="item.desc"></span>
          <a class="btn btn-primary" href="#" @click="editHtmlContent('desc',item,item.desc)"><i class="fa fa-pen"></i></a>
        </td>
      </tr>

      </tbody>
    </table>
    <DLGEditor ref="dlgEditor" v-on:returnOk="dlgEditorReturnOK" />

  </div>
</template>

<script>
/**

 **/
import arrayUtil from "@/util/arrayUtil";
import apiAdmin from "@/taylorCommon/apiAdmin";
import adminUtil from "@/taylorCommon/adminUtil";
import util from "@/util/util";
import {
  WebContent_QueryType_2_Sign,
} from "./js/fireGodsDeclare";
import _ from "lodash";
import DLGEditor from "@/taylorCommon/component/DLGEditor.vue";

export default {
  components: {DLGEditor},
  data: function () {
    return {
      datas:[],
      datasTemplate:[
        {
          id:"",
          seq:0,
          no:"",
          title1:"",
          title2:"",
          content:"",
          answer:"",
          desc:"",
        },
      ],
      WebContent_QueryType_2_Sign:WebContent_QueryType_2_Sign,
    };
  },
  methods: {
    loadData() {
      let that = this;
      apiAdmin.api_admWebContent_QueryContent(this.WebContent_QueryType_2_Sign).then((data)=>{
        let dataApi=adminUtil.ParseJsonOrDefaultArray(data.data.data);

        that.datas = _.sortBy(dataApi, ['seq']);

        // 補上空白的desc
        for (let item of that.datas) {
          if (!item.desc){
            this.$set(item,"desc","")
          }
        }
      })
    },
    submit(){
      apiAdmin.api_admWebContent_SaveContent(this.WebContent_QueryType_2_Sign,this.datas).then((data)=>{
        alert('儲存成功');
        this.loadData();
      })
    },
    DataItem_AddLast(){
      let newItem={...this.datasTemplate[0]};
      newItem.id =util.uuid();

      arrayUtil.orderAppendLast(newItem,this.datas,"orderKey")
    },
    DataItem_Remove(item){
      arrayUtil.removeByPredicate(this.datas,s => s.id===item.id);
    },
    editHtmlContent(param,item,htmlContent){
      this.$refs.dlgEditor.param=param;
      this.$refs.dlgEditor.callbackItem=item;
      this.$refs.dlgEditor.htmlContent=htmlContent;
      this.$refs.dlgEditor.showModal();
    },
    dlgEditorReturnOK(param,item){
      if (param==="content"){
        item.content=this.$refs.dlgEditor.htmlContent;
      }else if (param==="answer"){
        item.answer=this.$refs.dlgEditor.htmlContent;
      }else if (param==="desc"){
        item.desc=this.$refs.dlgEditor.htmlContent;
      }
    },

  },
  mounted() {
    this.loadData();
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
